// Données de référence pour les catégories et sous-catégories
export const CATEGORIES = [
  'Activités nature',
  'Bible & pédagogie spirituelle',
  'Bureautique',
  'Divers & vie quotidienne',
  'Jeux créé / personnalisés',
  'Jeux de société',
  'Jeux extérieurs',
  'Jouets et jeux d\'enfants',
  'Matériel créatif & manuel',
  'Matériel électronique',
  'Matériel vidéo',
  'Musique, son & lumières',
  'Pédagogie',
  'Sécurité & encadrement'
];

export const SOUS_CATEGORIES: Record<string, string[]> = {
  'Activités nature': [
    'Camping & itinérance',
    'Plage / Lac',
    'Randonnée',
    'Encadrement activités'
  ],
  'Bible & pédagogie spirituelle': [
    'Bibles',
    'Autres'
  ],
  'Bureautique': [
    'Fourniture de bureau'
  ],
  'Divers & vie quotidienne': [
    'Baby-foot / ping-pong',
    'Organisation',
    'Divers'
  ],
  'Jeux créé / personnalisés': [
    'Jeux collectifs',
    'Jeux immersifs'
  ],
  'Jeux de société': [
    'Classiques',
    'Coopératifs / éducatifs'
  ],
  'Jeux extérieurs': [
    'Ballons & sports',
    'Jeux collectifs',
    'Jeux immersifs',
    'Autres',
    'Encadrement activités'
  ],
  'Jouets et jeux d\'enfants': [
    'Jouets'
  ],
  'Matériel créatif & manuel': [
    'Arts plastiques',
    'Décors & costumes',
    'Travaux manuels'
  ],
  'Matériel électronique': [
    'Matériel électronique'
  ],
  'Matériel vidéo': [
    'Matériel vidéo'
  ],
  'Musique, son & lumières': [
    'Instruments',
    'Matériel Sono',
    'Matériel lumière',
    'Piles / batteries'
  ],
  'Pédagogie': [
    'Matériel visuel'
  ],
  'Sécurité & encadrement': [
    'Infirmerie'
  ]
};
